// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"786":"455d01771472837d","820":"455d01771472837d","888":"7be940732981b84d"}[chunkId] + ".css";
};